import * as React from "react";
import Input from "../Input-new/Input";
import Dropdown from "../Dropdown/Dropdown";

const LenderInfo = ({ data, handleChangeInput,handleChangeDropdown, viewMode, deleted }) => {
    return (
        <div className="Lender-info">
            <div className="Lender-info_column">
                <Input
                    className="Lender-info_column_item"
                    required
                    valueType="text"
                    name="NAME"
                    label="LENDER NAME"
                    value={data.NAME}
                    handleParentChange={handleChangeInput}
                    viewMode={viewMode}
                    deleted={deleted}
                />
                <Input
                    className="Lender-info_column_item"
                    valueType="text"
                    name="CITY"
                    label="CITY"
                    value={data.CITY}
                    handleParentChange={handleChangeInput}
                    viewMode={viewMode}
                    deleted={deleted}
                />

                <Dropdown
                    className="Lender-info_column_item"
                    data={data}
                    optionsType="states"
                    optionKey="abbr"
                    optionLabelKey="name"
                    value={data.STATE}
                    valueKey="STATE"
                    label="STATE"
                    handleParentChange={handleChangeDropdown}
                    viewMode={viewMode}
                    deleted={deleted}
                />
                <Input
                    className="Lender-info_column_item"
                    valueType="text"
                    name="CONTACT_NAME"
                    label="CONTACT NAME"
                    value={data.CONTACT_NAME}
                    handleParentChange={handleChangeInput}
                    viewMode={viewMode}
                    deleted={deleted}
                />
                <Input
                    className="Lender-info_column_item"
                    valueType="phone"
                    name="CONTACT_PHONE"
                    label= "PHONE #"
                    value={data.CONTACT_PHONE}
                    handleParentChange={handleChangeInput}
                    viewMode={viewMode}
                    deleted={deleted}
                />
                <Input
                    className="Lender-info_column_item"
                    valueType="email"
                    name="CONTACT_EMAIL"
                    label= "EMAIL"
                    value={data.CONTACT_EMAIL}
                    handleParentChange={handleChangeInput}
                    viewMode={viewMode}
                    deleted={deleted}
                />
            </div>
        </div>
    );
};

export default LenderInfo;
